export default {
  init() {
    // JavaScript to be fired on all pages

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    var section = [];

    var new_div;
    // go through all the Gravity Forms fields
    $('.gfield').each( function() {
        // if the field is a section create a new array for fields and a new container to append the fields
        if ( $(this).hasClass('gsection') && !$(this).hasClass('nada-collapse') ) {
            if ( section.length > 0 ) {
                section = [];
            }
            new_div = $('<div class="m_section"></div>');
            new_div.insertAfter($(this));
        } else {
            // check if the field is the the kind you want to use for the accordion
            if ( $(this).hasClass('gfield_price') && !$(this).hasClass('nada-collapse') ) {
                // if it's the first element add a custom text to the section name
                if ( section.length == 0 ) {
                    $(this).prevAll(".gsection:first").find('.gsection_title').append(' <span class="m_expand"><span class="m_expand_text">+</span><span class="m_collapse_text">-</span></span>');
                }
                // add the field to the section array for reference
                section.push($(this));
                // move the field in the container for the section
                if ( new_div ) {
                    new_div.append($(this));
                }
            }
        }
    });

    // add the section click behavior
    $('.gsection').click(function(e) {
        e.preventDefault();
        // toggle the text
        $('.gsection').removeClass('show_collapse');

        // if the section content is already visible just hide it ( toggle )
        if ( $(this).next().is(':hidden') ) {
          // hide all sections
          $('.m_section').hide();
          $(this).next().show();

          // toggle the text
          $(this).addClass('show_collapse');
        } else {
          // hide all sections
          $('.m_section').hide();
          $(this).removeClass('show_collapse');
        }

    });

    // hide all section containers on first run, can be replaced by a css rule
    $('.m_section').hide();

    $.each($('.gf_step'), function(index) {
      var findex = index + 1;
      $(".gf_step[id$='"+ findex +"']").click(function() {
        $("#gform_target_page_number_2").val(""+ findex +"");
        $("#gform_2").trigger("submit",[true]);
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/local-pickup-delivery.js